// eslint-disable-next-line no-useless-escape, max-len
const emailRegex = /^(([A-Za-z0-9]+_+)|([A-Za-z0-9]+\-+)|([A-Za-z0-9]+\.+)|([A-Za-z0-9]+\++))*[A-Za-z0-9]+@((\w+\-+)|(\w+\.))*\w{1,63}\.[a-zA-Z]{2,6}$/;

// eslint-disable-next-line import/prefer-default-export
export function validEmail(email) {
  return emailRegex.test(String(email).toLowerCase());
}
